module.exports = __webpack_public_path__ + "assets/img/104.b52741cf.png";